import { orderTypes } from "@/store/types/store-types.js";
import {
  fetchUsersWithTodayOrder,
  arrangeSingleUserOrderList,
  fetchUsersWithAllOrder
} from "@/store/actions/order.js";
import api from "@/api";
import * as moment from "moment";
const state = {
  orderList: [],
  todayOrderList: [],
  singleUserOrderList: [],
  totalOrderList: []
};
const getters = {
  [orderTypes.getters.getOrderList]: state => state.orderList,
  [orderTypes.getters.getTodayOrderList]: state => state.todayOrderList,
  [orderTypes.getters.getTotalOrderList]: state => state.totalOrderList,
  [orderTypes.getters.getUser](state, getters, rootState) {
    return Number(rootState.route.params.id);
  }
};
const mutations = {
  [orderTypes.mutations.SET_ORDER_LIST]: (state, orderList) =>
    (state.orderList = orderList),
  [orderTypes.mutations.SET_SINGLE_USER_ORDER_LIST]: (
    state,
    singleUserOrderList
  ) => (state.singleUserOrderList = singleUserOrderList),
  [orderTypes.mutations.SET_TODAY_ORDER_LIST]: (state, todayOrderList) =>
    (state.todayOrderList = todayOrderList),
  [orderTypes.mutations.SET_TOTAL_ORDER_LIST]: (state, totalOrderList) =>
    (state.totalOrderList = totalOrderList),
  [orderTypes.mutations.SCAN_ORDER_LIST]: (state, totalOrderList) =>
    (state.orderList = totalOrderList)
};

const actions = {
  [orderTypes.actions.QUERY_TODAY_ORDER_LIST]: ({ commit }, date) => {
    let req = {
      delivered_at: date
    };
    return api.getTodayOrderList(req).then(data => {
      commit(orderTypes.mutations.SET_ORDER_LIST, data.orders);
      return data.orders;
    });
  },
  [orderTypes.actions.QUERY_ORDER_TOTAL]: ({ commit }, date) => {
    let req = {
      delivered_at: date
    };
    return api.getOrderTotalList(req).then(data => {
      commit(orderTypes.mutations.SET_TOTAL_ORDER_LIST, data.orders);
    });
  },
  [orderTypes.actions.ADD_ORDER]: (_, data) => {
    let orders = {
      orders: data
    };
    return api.addOrder(orders);
  },
  [orderTypes.actions.EDIT_ORDER]: (_, data) => {
    let id = data.id;
    delete data.id;
    return api.editOrder(id, data);
  },
  [orderTypes.actions.DELETE_ORDER]: (_, id) => {
    return api.deleteOrder(id);
  },
  [orderTypes.actions.QUERY_USER_ORDER_IN_MONTH]: ({ commit }, data) => {
    return api.getUserOrderInMonth(data.id, data.date).then(res => {
      commit(orderTypes.mutations.SET_SINGLE_USER_ORDER_LIST, res);
      return res;
    });
  },
  [orderTypes.actions.GET_TODAY_ORDER_LIST]: async (
    { dispatch, commit, state },
    date
  ) => {
    await dispatch(orderTypes.actions.QUERY_ORDER_TOTAL, date);
    let orderAllList = state.totalOrderList;
    let userList = await fetchUsersWithTodayOrder(orderAllList);

    Promise.all(userList).then(results => {
      results = results.filter(user => user.orderList.length !== 0);
      commit(orderTypes.mutations.SET_TODAY_ORDER_LIST, results);
    });
  },
  [orderTypes.actions.GET_ORDER_SETTLED_LIST]: async (
    { dispatch, state, commit },
    date
  ) => {
    await dispatch(orderTypes.actions.QUERY_ORDER_TOTAL, date);
    let nowDate = {
      delivered_at: moment().format("YYYY-MM-DD")
    };
    let userList = fetchUsersWithAllOrder(state.totalOrderList, nowDate);
    await Promise.all(userList).then(list => {
      commit(orderTypes.mutations.SET_ORDER_LIST, list);
      return list;
    });
  },
  [orderTypes.actions.GET_SINGLE_USER_ORDER_LIST]: async (
    { dispatch, commit, state, rootState },
    date
  ) => {
    let routeIndex = Number(rootState.route.params.id);
    let req = {
      id: routeIndex
    };
    req.date = date;
    await dispatch(orderTypes.actions.QUERY_USER_ORDER_IN_MONTH, req);
    return arrangeSingleUserOrderList(
      state,
      commit,
      orderTypes.mutations.SET_ORDER_LIST
    );
  },
  [orderTypes.actions.EDIT_BAG]: (_, data) => {
    return api.editBag(data).then(res => {
      return res;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
